import { format } from "date-fns";
import { es } from "date-fns/locale";

export const formatDateTime = (date: Date | undefined): string => {
    //return date ? format(date, "dd 'de' MMMM yyyy 'a las' hh:mm aaa", { locale: es }) : "";
    return date ? format(date, "dd/MM/yyyy hh:mm aaa", { locale: es }) : "";
};

export const hoursPassedSince = (date: Date) => {
    const realDate = new Date(date);
    const now = new Date();
    const diff = now.getTime() - realDate.getTime();
    const realDiff = Math.ceil(diff / (1000 * 3600));
    return realDiff;
};

export const daysPassedSince = (date: Date | undefined) => {
    if (!date) {
        return "";
    }
    const realDate = new Date(date);
    const now = new Date();
    const diff = now.getTime() - realDate.getTime();
    const realDiff = Math.floor(diff / (1000 * 3600 * 24));
    return realDiff;
};
